import classNames from "classnames";
import React from "react";
import Heading from "../../../elements/heading";
import BodyText from "../../../elements/body-text";
import Image from "../../../elements/image";
import { RichText } from "@sitecore-jss/sitecore-jss-react";

const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
  </svg>
);

const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
  </svg>
);

const GridContent = ({ imageGallery, headingBody, headingType, headingTypographyClass, overlineText, body, backgroundColor, paddingAboveTop, paddingAboveBottom, alignment, slideWidth, onItemClicked }) => {
  let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
    bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "default",
    alignContent = alignment ? alignment.fields.phrase.value : "";

  const imageGridContentClasses = classNames(`padding-top-${top}`, `padding-bottom-${bottom}`, "image-grid", "grid"),
    itemsClasses = classNames("gallery-container");

  let divHeroMediaBackgroundStyle = {};

  if (backgroundColor) {
    divHeroMediaBackgroundStyle = {
      background: backgroundColor ? backgroundColor.fields.phrase.value : ""
    };
  }
  const overlineClasses = classNames("overline", alignContent),
    headingClasses = classNames("title show-on-scroll", alignContent),
    bodyTextClasses = classNames("body-text", alignContent);

  return (
    <div className={imageGridContentClasses} style={divHeroMediaBackgroundStyle}>
      <div ref={slideWidth} className={"slide-width"} />
      {overlineText.value && <span className={overlineClasses}>{overlineText.value}</span>}
      {headingBody && headingBody.value && (
        <Heading
          {...{
            type: headingType,
            html: headingBody,
            typographyClass: headingTypographyClass ? headingTypographyClass.value : "type-h1"
          }}
          className={headingClasses}
        />
      )}
      {body && body.value && <BodyText html={body?.value} className={bodyTextClasses} tag="div" />}
      <div className={itemsClasses}>
        {imageGallery &&
          imageGallery.map((row, rowIndex) => {
            let rowClasses = classNames("gallery-row", {
              one: row.length === 1,
              two: row.length === 2,
              three: row.length === 3
            });

            return (
              <div className={rowClasses} key={rowIndex}>
                {row.map((item, itemIndex) => {
                  let style = {
                    backgroundColor: item.fields.backgroundColor ? item.fields.backgroundColor.fields.phrase.value : ""
                  };
                  if (row.length === 2 && item.image) {
                    let ratioWidthItem1 = (110 / row[0].image.height) * row[0].image.width;
                    let ratioWidthItem2 = (110 / row[1].image.height) * row[1].image.width;
                    let widthPercent;
                    if (itemIndex === 0) {
                      widthPercent = ratioWidthItem1 / (ratioWidthItem1 + ratioWidthItem2);
                    } else {
                      widthPercent = ratioWidthItem2 / (ratioWidthItem1 + ratioWidthItem2);
                    }
                    style = { ...style, width: widthPercent * 100 + "%" };
                  }
                  let galleryItemClasses = classNames("gallery-item", {
                    "no-image": item.image.type === undefined
                  });
                  let overlayClasses = classNames("image-overlay", "show-on-scroll", {
                    "no-image": item.image.type === undefined
                  });

                  return (
                    <div style={style} key={itemIndex} className={galleryItemClasses} onClick={e => onItemClicked(e, rowIndex, itemIndex)}>
                      {item && item.image && <Image {...item.image} />}
                      {/* {item && item.image.type === "video" && (
                      <div className={"image"}>
                        <img src={item.image.poster} alt={""} />
                      </div>
                    )} */}

                      <div className={overlayClasses}>
                        {item && item.fields.headingBody.value && (
                          <Heading
                            {...{
                              type: item.fields.headingType || {
                                fields: { phrase: { value: "span" } }
                              },
                              html: item.fields.headingBody,
                              typographyClass: item.headingTypographyClass ? headingTypographyClass.value : "type-h2"
                            }}
                            className={"overlay-content"}
                          />
                        )}
                        <div className={"icon-content"}>
                          {item.image.type !== "video" && <ArrowIcon />}
                          {item.image.type === "video" && item.image.icon.value === "" && <PlayIcon />}
                          {item.image.type === "video" && item.image.icon.value !== "" && <RichText tag="span" field={item.image.icon} />}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default GridContent;
